export const MANUAL_VERSIONS = ['2020', '2024', '2024_1'] as const

export type ManualVersion = (typeof MANUAL_VERSIONS)[number]
